export default __webpack_public_path__ + "fr/static/media/Mastercard_2019_logo.32139558.svg";